<template>
  <div class="solubility">
    <container>
      <template v-slot:header>
        {{$ml.get(`SOLUBILITY, `)}}{{$store.getters['unit/getLabel']('g/L')}}
      </template>
      <div class="content">
        <div v-for="(value, key, i) in data" :key="i">
          <span>
            {{$store.getters['unit/convert']('C', 5*i)}}{{$store.getters['unit/getLabel']('C')}}
          </span>
          <span>
            {{$store.getters['unit/convert']('g/L', value)}}
          </span>
        </div>
      </div>
    </container>
  </div>
</template>

<script>
import Container from "@/components/common/HeadedContainer"

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Container
  }
}
</script>

<style lang="scss" scoped>
  .solubility {
    .content {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
      padding: 15px;
      box-sizing: border-box;
      position: relative;

      &:before {
        content: '';
        display: block;
        position: absolute;
        width: calc(100% - 30px);
        height: 1px;
        background: rgba(76, 80, 86, 0.1);
        left: 15px;
        top: 50%;
      }

      div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        span {
          margin: 0;

          &:first-child {
            margin-bottom: 20px;
            font-weight: 500;
            font-size: 13px;
          }
          &:last-child {
            font-size: 16px;
            font-weight: 400;
            margin-top: 20px;
          }
        }
      }
    }
  }
</style>
